import isEqual from 'lodash/isEqual';
import { useRef } from 'react';

var useStableValue = function useStableValue(newValue) {
  var prevValueRef = useRef(newValue);

  if (!isEqual(prevValueRef.current, newValue)) {
    prevValueRef.current = newValue;
  }

  return prevValueRef.current;
};

export default useStableValue;